<template>
  <div>
    <Head title="Team bearbeiten" />
    <div class="flex items-center mb-8 text-orfBlue-100 text-3xl font-bold">
      <loading-button text="Zurück" inverted icon-name="arrow-left" func="link" :href="'/departments/' + department.id + '/edit'" class="mb-4 sm:mb-0 sm:mr-4"/>
      <HeroIcon name="flag" class="mr-2 h-10 w-10 fill-orfBlue-100" />
      <Link class="text-orfBlue-400 hover:text-orfBlue-600 mt-1" :href="'/departments/' + department.id + '/edit'">{{department.name}}</Link>
      <span class="text-orfBlue-400 font-medium mx-2 mt-1">/</span>
      <div class="text-orfBlue-400 hover:text-orfBlue-600 mt-1">Teams</div>
      <span class="text-orfBlue-400 font-medium mx-2 mt-1">/</span>
      <div class="text-orfBlue-400 hover:text-orfBlue-600 mt-1">
        {{ form.name }}
      </div>
    </div>
    <div class="max-w-2xl bg-white rounded-md shadow" v-if="team.id ">
      <form @submit.prevent="update">
        <div class="flex items-center justify-between">
          <div class="flex flex-wrap p-8 w-2/3">
            <text-input v-model="form.name" :error="form.errors.name" class="items-center justify-between w-full" label="Name" />
          </div>
          <div class="flex flex-col items-center p-8 w-1/3" v-if="false">
            <label class="form-label" for="color">Farbe: </label>
            <input id="color" v-model="form.color" type="color" :style="['background: ' + form.color]" class="w-10 h-10 rounded-full shadow cursor-pointer" />
          </div>
        </div>
        <div class="flex items-center justify-end sm:px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button v-if="!team.deleted_at && team.id != 1" :loading="form.processing" text="Team löschen" func="delete" inverted small icon-name="trash" icon-mini @click.prevent="destroy"/>
          <loading-button :loading="form.processing" text="Aktualisieren" class="ml-auto" icon-name="save" icon-custom-icon/>
        </div>
      </form>
    </div>
    <div v-if="team.id" class="flex items-center flex-wrap justify-between mt-12 ">
      <h2 class="text-2xl font-bold">Team Mitglieder ( {{team.users.length}} )</h2>
      <loading-button text="Mitarbeiter/In erstellen" icon-name="add" icon-custom-icon func="link" :href="'/departments/' + department.id + '/teams/' + team.id + '/users/create'" class="mb-4 sm:mb-0"/>
    </div>
    <div class="mt-4 bg-white rounded shadow overflow-x-auto">
      <div class="w-full whitespace-nowrap">
        <div class="lg:flex items-center font-bold text-left hidden">
          <div class="pb-4 pt-6 px-6 w-1/4">Name</div>
          <div class="pb-4 pt-6 px-6 flex-grow">Email</div>
          <div class="pb-4 pt-6 px-6 w-1/4 text-right">Optionen</div>
        </div>
        <div v-for="user in team.users" :key="user.id" class="flex-wrap flex items-center border-t hover:bg-gray-100 focus-within:bg-gray-100">
          <div class="lg:w-1/4 w-full">
            <Link class="flex items-center px-6 py-4 focus:text-orfBlue-500 justify-between" :href="`/users/${user.id}/edit`">
              {{ user.first_name }} {{ user.last_name }}
              <HeroIcon v-if="user.deleted_at" name="trash" icon-mini class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              <loading-button text="Kalender" icon-name="search" icon-custom-icon func="link" small :href="`/?user=${user.id}`" class="flex lg:hidden"/>
            </Link>
          </div>
          <div class="lg:flex-grow">
            <Link class="flex items-center px-6 py-4 text-xs lg:text-sm" :href="`/users/${user.id}/edit`" tabindex="-1">
              {{ user.email }}
            </Link>
          </div>
          <div class="lg:w-1/4 px-6 py-4 w-full flex h-full items-center justify-between lg:justify-end">
              <loading-button v-if="is_admin && team.id" text="Entfernen" func="delete" small inverted icon-name="trash" icon-mini @click.prevent="removeUser(user.id)"/>
              <loading-button text="Bearbeiten" small inverted icon-name="pencil-square" icon-mini func="link" :href="`/users/${user.id}/edit`"/>
              <loading-button text="Kalender" icon-name="search" icon-custom-icon func="link" small :href="`/?user=${user.id}`" class="hidden lg:flex"/>
          </div>
        </div>
        <div v-if="team.users.length === 0">
          <div class="px-6 py-4 border-t" colspan="4">Keine Mitarbeiter gefunden.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import HeroIcon from '@/Shared/HeroIcon.vue'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Search from '@/Shared/Search.vue'

export default {
  components: {
    Head,
    HeroIcon,
    Link,
    LoadingButton,
    TextInput,
    TrashedMessage,
    Search,
  },
  layout: Layout,
  props: {
    auth: Object,
    filters: Object,
    userSearch: Object,
    users: Array,
    team: Object,
    department: Object,
    is_admin: Boolean,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.team.name,
        color: this.team.color,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/departments/${this.department.id}/teams/${this.team.id}`)
    },
    removeUser(userId) {
      if (confirm('Bist du dir sicher?')) {
        this.form.delete(`/departments/${this.department.id}/teams/${this.team.id}/${userId}`)
      }
    },
    destroy() {
      if (confirm('Are you sure you want to delete this team? All team users will go into "Kein Team"')) {
        this.$inertia.delete(`/departments/${this.department.id}/teams/${this.team.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this team?')) {
        this.$inertia.put(`/departments/${this.department.id}/teams/${this.team.id}/restore`)
      }
    },
  },
}
</script>
